import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserIcon, Building, ArrowLeft } from '@one-of-one/icons';
import { Location } from '@angular/common';
import { Footer } from '@one-of-one/footer';

@Component({
  selector: 'app-single-registration',
  imports: [Footer, UserIcon, Building, ArrowLeft, Footer],
  templateUrl: './single-registration.html',
})
export class SingleRegistration {
  private readonly router = inject(Router);
  private readonly location = inject(Location);

  navigate(toSimple: boolean) {
    const route = toSimple
      ? 'single-registration/simple'
      : 'single-registration/with-accomodation';
    this.router.navigate([route]);
  }

  goBack() {
    this.location.back();
  }
}
